import { Identifiable, ProjectReport } from "@planzone/dto";
import { Filter } from "@planzone/dto";

import { isFilteredByGroups } from "./groups";
import { isFilteredByResources } from "./resources";

function isProjectReportFiltered(
  report: Identifiable<ProjectReport>,
  filter: Filter,
): boolean {
  return [isFilteredByGroups, isFilteredByResources].reduce(
    (isFiltered, applyFilter) =>
      isFiltered ? isFiltered : applyFilter(report, filter),
    false,
  );
}

export { isProjectReportFiltered };
